import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';

import { MAT_DIALOG_DATA, MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { AppInfo } from '../../services/app-info.service';
import { RouterModule } from '@angular/router';
import { PwaService } from '../../services/pwa.service';
import { environment } from '../../../environments/environment';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-app-info-dialog',
  standalone: true,
  imports: [MatDialogModule, MatButtonModule, MatIconModule, RouterModule],
  template: `
    <div class="app-info-dialog">
    
      <h2 class="title">O aplikacji</h2>
    
    
      <div mat-dialog-content class="dialog-content">
        <div class="version-info">
          <div class="info-row">
            <span class="label">Wersja:</span>
            <span class="value">{{ version }}</span>
          </div>

                  @if ( data.releaseDate) {
          <div class="info-row">
            <span class="label">Data wydania:</span>
            <span class="value">{{ formattedDate }}</span>
          </div>
        }
    
    
  
          @if (data.buildNumber) {
            <div class="info-row center">
              <button mat-button (click)="clearData()">Wyczyść pamięć podręczną</button>
            </div>
          }
    
    
    
    
        </div>
    
        @if (false && data.releaseNotes && data.releaseNotes.length > 0) {
          <div class="release-notes">
            <h3>Najnowsze zmiany:</h3>
            <ul>
              @for (note of data.releaseNotes; track note) {
                <li>{{ note }}</li>
              }
            </ul>
          </div>
        }


    
    
      @if (false) {
        <div class="app-description">
          <p>Przeczytaj więcej o naszej aplikacji -> <a routerLinkActive="is-active" mat-list-item
            [routerLink]="['/tresc/aplikacja']"
            (click)="close()"
            style="text-decoration:none; color:inherit; font-size: 0.9rem;">
            ZGrane Grono - Aplikacja mobilna
          </a></p>
        </div>
      }
      </div>
    
      <div mat-dialog-actions class="dialog-actions">
        <button class="custom-button" (click)="close()" color="primary">
          Zamknij
        </button>
      </div>
    </div>
    `,
  changeDetection: ChangeDetectionStrategy.Eager,
  styles: [`
    .app-info-dialog {
      width: calc(100% - 30px);
      padding: 15px;
    }

   
   
    .dialog-content {
      padding: 16px 0;
    }

    .version-info {
      margin-bottom: 20px;
      
      .info-row {
        display: flex;
        justify-content: space-between;
        padding: 8px 0;
        border-bottom: 1px solid #f0f0f0;
        
        &:last-child {
          border-bottom: none;
        }

        .label {
          font-weight: 500;
          color: #666;
        }

        .value {
          color: #333;
        }
      }
    }

    .release-notes {
      margin: 20px 0;
      
      h3 {
        margin: 0 0 12px 0;
        color: #333;
      }

      ul {
        margin: 0;
        padding-left: 20px;
        
        li {
          margin-bottom: 6px;
          color: #666;
        }
      }
    }

    .app-description {
      margin-top: 20px;
      padding-top: 16px;
      border-top: 1px solid #e0e0e0;
      
      p {
        margin: 0;
      }
    }

    .dialog-actions {
      display: flex;
      justify-content: flex-end;
      padding: 16px 0 0 0;
    }
  `]
})
export class AppInfoDialogComponent {

  formattedDate: string;
  version = environment.version;
  constructor(
    public dialogRef: MatDialogRef<AppInfoDialogComponent>,
    public pwaService: PwaService,
    private snackBar: MatSnackBar,
    @Inject(MAT_DIALOG_DATA) public data: AppInfo
  ) {
    this.formattedDate = new Date(data.releaseDate).toLocaleDateString('pl-PL', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  }

    clearData(): void {
    // Delegate to PwaService which handles clearing and reload
    // Only clear data if online
    if (navigator.onLine) {
      this.pwaService.clearData(undefined);
    } else {
      console.warn('Cannot clear data while offline.');
      this.snackBar.open('Nie można wyczyścić danych podczas pracy offline.', 'Zamknij', {
        duration: 3000,
      });
    }
  }

  close(): void {
    this.dialogRef.close();
  }
}